import { render, staticRenderFns } from "./Presupuestos.vue?vue&type=template&id=44c22bcc&scoped=true"
import script from "./Presupuestos.vue?vue&type=script&lang=js"
export * from "./Presupuestos.vue?vue&type=script&lang=js"
import style0 from "./Presupuestos.vue?vue&type=style&index=0&id=44c22bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c22bcc",
  null
  
)

export default component.exports